$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
BoardMemberMenuView = require 'views/member-menu-profile/board-member-menu-view'
BoardOrgMemberView = require 'views/board-menu/board-org-member-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
DisplayInvitationLinkView = require 'views/invitation-link/display-invitation-link-view'
getExperiment = require 'lib/experiments/simple-test'
Invitation = require 'models/invitation'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
manageMembersTemplate = require 'views/templates/manage_members'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
Member = require 'models/member'
MemberAddView = require 'views/member/member-add-view'
MemberSearchView = require 'views/search/member-search-view'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
SelectMemberView = require 'views/member/select-member-view'
Util = require 'lib/util'
containsValidUrl = require 'lib/util/url/contains-valid-url'
View = require 'view'
_ = require 'underscore'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
inviteAddNameTemplate = require 'views/templates/invite_add_name'
track = require 'debug/track'
l = require 'lib/localize'

INLINE_EMPTY_STATE_KEY = 'inline-invite-empty-state'

module.exports = class BoardMembersView extends View
  mixin MemberSearchView, MemberAddView, DisplayInvitationLinkView, @

  viewTitleKey: 'members'

  initialize: ->
    organization = @model.getOrganization()
    if organization?
      @listenTo organization.memberList, 'add remove reset',
        @frameDebounce @renderOrgMembers
    @listenTo @model.memberList, 'add remove reset',
      @frameDebounce @renderOrgMembers

    # in case the bc org admins decides to change the invite permissions
    # when you are looking at this view.
    if organization?
      @listenTo organization, 'change:prefs', @frameDebounce @render

    @savedSearch = ""
    return

  events:

    # board members
    'click .js-board-members .js-select-member': 'showMemberMenu'

    # send invites
    'click .js-search-results .js-select-member': 'didClickAddOtherMember'
    'paste .js-search-input': 'searchPaste'

    # org member stuff
    'click .js-org-members .js-select-member': 'didClickAddOrgMember'
    'click .js-org-members .js-add-all-org-members': 'didClickAddAllOrgMembers'
    'click .js-org-members .js-more-org-members': 'didClickViewMoreOrgMembers'

    # remove invite
    'click .js-remove-invitation': 'removeInvitation'

    # send email invite to new email address
    'click .js-send-email-invite': 'sendEmailInvite'
    'submit .js-email-data': 'sendEmailInvite'

    # etc
    'click .js-open-option': 'openOptionOrError'
    'mouseenter .js-select-member': 'hoverMember'

    # invitation links
    'click .js-show-invitation-link': 'showInvitationLink'
    'click .js-invitation-link': 'clickInvitationLink'
    'click .js-deactivate-link': 'deactivateInvitationLink'

  render: ->
    data = {}
    data.placeholder = l('add member placeholder')
    data.canAddMembers = @model.canInviteMembers()

    organization = @model.getOrganization()
    if organization?
      data.orgName = organization.get('displayName')

    data.canInviteMembers = data.canAddMembers && !(organization?.externalMembersDisabled())
    data.disableAddingExternalMembers = @model.isMember(Auth.me()) && organization?.externalMembersDisabled()
    data.isBCOrgAdmin = organization?.isPremOrgAdmin(Auth.me())
    data.orgSettingsURL = if organization? then Controller.getOrganizationAccountUrl(organization) else ""
    data.editable = @model.editable()

    @$el.html(manageMembersTemplate(data))

    # just show current board members if you don't have add member perms
    if data.canAddMembers
      @setTimeout =>
        @renderOrgMembers()
        @input = @$('.js-search-input')
        @input
          .click((e) -> Util.stop(e))
          .keyup(@debounce(@search, 500).bind(@))
          .keydown(@keydownEvent.bind(@))
          .focus()
        if @savedSearch
          @input.val(@savedSearch)
          @search()
          @savedSearch = ''

      , 10
    else
      @setTimeout =>
        @renderBoardMembers()
      , 10

    @lastSearch = ''
    @loadingEl = @$('.js-loading')
    @helperEl = @$('.js-helper')

    @

  loadOrgData: ->
    organization = @model.getOrganization()
    if organization? and @model.editable()
      ModelLoader.loadOrganizationMembersMinimal organization.id
      .then =>
        @renderOrgMembers()
        return
      .done()
    return

  renderBoardMembers: ->
    $boardMemberSection = @$('.js-board-members').hide()
    $boardMemberList = $boardMemberSection.find('.js-list').empty()

    if @model.memberList.models.length > 7
      $boardMemberList.addClass('collapsed')

    for member in @model.memberList.models
      @appendSubview(@subview(SelectMemberView, member), $boardMemberList)

    $boardMemberSection.show()

    return

  renderOrgMembers: ->
    $orgMemberSection = @$('.js-org-members').hide()
    $orgMemberList = $orgMemberSection.find('.js-list').empty()
    $addAllOrgMembersButton = $orgMemberSection.find('.js-add-all-org-members').empty()
    $viewMore = $orgMemberSection.find('.js-more-org-members').addClass('hide')

    org = @model.getOrganization()
    if org?
      memsAvailable = @model.orgMembersAvailable()

      if memsAvailable.length > 0

        viewMore = false
        if memsAvailable.length > 7
          viewMore = true
          $viewMore.removeClass('hide')

        memsAvailableSlice = memsAvailable.slice(0, 7)

        _.each memsAvailableSlice, (member) =>
          data = member.toJSON()

          if org?.isPremOrgAdmin(member)
            data.className = "no-option"

          $orgMemberList.append(
            templates.fill(
              'select_member',
              data,
              {},
              { member: templates.member }
            )
          )

        formatArgs =
          count: memsAvailable.length.toString()
        $addAllOrgMembersButton.text l('add all org members', formatArgs)
        $orgMemberSection.show()

    return

  renderEmailInviteToSearchResults: (data) ->
    puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/
    puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/

    fullName = _.compact(Util.removeDomainFromEmailAddress(data.email).split(puncSpacePattern)).join(" ").replace(puncPattern, "")
    data.fullName = Util.toTitleCase(fullName)
    data.canAddAsObserver = @model.getOrganization()?.isFeatureEnabled('observers')
    data.modelType = 'Board'

    externalMembersDisabled = @model.getOrganization()?.get('prefs').externalMembersDisabled
    @$('.js-no-results').toggleClass('hide', !externalMembersDisabled)
    if !externalMembersDisabled
      @$('.js-uninvited-search-results').append inviteAddNameTemplate(data)
      .show()

  # show member detail
  showMemberMenu: (e) ->
    Util.stop(e)

    idMem = $(e.target).closest('.js-select-member').attr('idMember')
    member = @modelCache.get('Member', idMem)

    PopOver.pushView
      view: new BoardMemberMenuView({ model: member, board: @model, @modelCache })

    return

  # search
  searchPaste: ->
    @loadingEl.show()
    @input.keyup()

  search: (e) ->
    # We don't want to use key codes here since this is a debounced event
    return if @lastSearch? && @lastSearch == @input.val()
    @lastSearch = @input.val()

    search = @input.val().toLowerCase().trim()

    if search == ''
      @clearSearchResults()
      return

    @loadingEl.show()
    org = @model.getOrganization()
    if search.length > 2
      ApiAjax
        url: '/1/search/members/'
        type: 'get'
        data:
          idBoard: @model.id
          query: search
          idOrganization: org?.id
          onlyOrgMembers: org?.externalMembersDisabled()
        dataType: 'json'
        success: (data) =>
          @renderSearchResults(search, data)
    else if org?
      # The server isn't going to give us any results for searches that are
      # 2 characters or less … we can at least help by trying to see if there
      # are team members that would match
      orgResults = org.memberList.chain()
        .filter (member) ->
          _.any Util.getMemNameArray(member), (part) ->
            part.indexOf(search) == 0
        .map (member) =>
          _.extend member.toJSON(), {
            active: true,
            similarity: 0,
            joined: @model.hasActiveMembership(member)
          }
        .value()
      @renderSearchResults(search, orgResults)
    else
      @renderSearchResults(search, [])
    return

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)

    if key == Keys.Enter
      if @$('.js-search-results .js-list .selected .js-select-member').length > 0
        Util.stop(e)
        @$('.js-search-results .js-list .selected:first .js-select-member').click()

      else if @$('.js-search-results .js-list .email-invite').length > 0
        Util.stop(e)
        @$('.email-invite:first').click()

    # navigate menu list
    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$('.js-search-results .js-list'), 'li', key)

    return

  clearSearchResults: ->
    @helperEl.show()
    @lastSearch = ''
    @input.val('').focus().select()
    @$('.js-search-results').hide()
    @$('.js-uninvited-search-results').empty().hide()
    @renderOrgMembers()

  # remove invite
  removeInvitation: (e) ->
    id = $(e.currentTarget).closest('.invitation').data('id')
    Invitation::delete
      model: @model
      idInvitation: id
      success: =>
        track("Invitations", "Delete Board Invite")
        @search
    Util.setCaretAtEnd(@input[0])
    return

  # perms
  canRemoveInvitation: (invitation) -> invitation.get('idMemberInviter') == Auth.myId() || @model.owned()

  sendEmailInvite: (e) ->
    Util.stop(e)
    $sendButton = @$('.js-send-email-invite')
    # The email is already being sent
    if $sendButton.attr('disabled')?
      return

    $name = @$('.js-email-data .js-full-name')
    name = $name.val().trim()

    if !Util.validName(name)
      Util.setCaretAtEnd($name)
      $('.js-name-error').show()
      return
    else if containsValidUrl(name)
      # Urls are not allowed as member names
      Util.setCaretAtEnd($name)
      $('.js-name-error-url').show()
      return

    data =
      fullName: name
      email: @$('.js-email-data .js-email').val().trim()
      type: 'normal'

    if @$('#addAsObserver').is(':checked')
      data.type = 'observer'

    if maybeDisplayMemberLimitsError($(e.target), @model)
      return

    if getExperiment('boardSearchEmptyStates').get('enabled')
      Auth.me().dismiss(INLINE_EMPTY_STATE_KEY)

    # Disable the button while we're sending the invite
    $sendButton.attr('disabled', 'disabled')

    ApiAjax
      url: "/1/board/#{@model.id}/members"
      type: 'put'
      dataType: 'json'
      data: data
      success: (data) =>
        member = new Member(data, modelCache: @modelCache)
        @renderOrgMembers()
        track("Invitations", "Send Email Board Invite to New Member", "Role: #{data.type}")

        $sendButton.removeAttr('disabled')
        PopOver.hide()
      error: (res, err) =>
        $('.pop-over-section.js-error').show().find('.error').html(res.responseText)
        @$('.js-uninvited-search-results').empty().hide()
        $sendButton.removeAttr('disabled')
        @input.focus().select()
        track("Invitations", "Error", res.responseText)
        return

    return

  addMember: (e, idMember) ->
    member = @modelCache.get('Member', idMember)
    if maybeDisplayMemberLimitsError($(e.target), @model, member)
      return
    @model.addMember(member)

    if getExperiment('boardSearchEmptyStates').get('enabled')
      Auth.me().dismiss(INLINE_EMPTY_STATE_KEY)

    @renderOrgMembers()
    return

  didClickAddOtherMember: (e) ->
    Util.stop(e)
    return if $(e.target).closest('.item.disabled').length > 0

    idMember = $(e?.target).closest('.js-select-member').attr('idMember')

    @clearSearchResults()

    organization = @model.getOrganization()
    member = @modelCache.get('Member', idMember)
    if member && organization?.isMember(member)
      track("Invitations", "Add Org Member to Board", "Role: Member")
    else
      track("Invitations", "Add Other Member to Board", "Role: Member")

    @addMember(e, idMember)

  didClickAddOrgMember: (e) ->
    Util.stop(e)
    track("Invitations", "Add Org Member to Board (via List)", "Role: Member")

    idMember = $(e?.target).closest('.js-select-member').attr('idMember')
    @addMember(e, idMember)

  didClickAddAllOrgMembers: (e) ->
    Util.stop(e)
    track("Invitations", "Add All Org Members to Board")

    memsAvailable = @model.orgMembersAvailable()
    memberCount = memsAvailable.length.toString()

    if getExperiment('boardSearchEmptyStates').get('enabled')
      Auth.me().dismiss(INLINE_EMPTY_STATE_KEY)

    Confirm.pushView 'add all org members',
      model: @model
      html: l('confirm.add all org members.text', { memberCount })
      confirmBtnClass: 'primary'
      fxConfirm: (e) =>
        for member in memsAvailable
          if maybeDisplayMemberLimitsError($(e.target), @model, member)
            return
          @model.addMember(member)

  didClickViewMoreOrgMembers: (e) ->
    Util.stop(e)
    track('Invitations', 'View More Org Members')

    PopOver.pushView
      view: new BoardOrgMemberView({ @model, @modelCache })

    return

  willBePushedDown: ->
    @savedSearch = @input.val()

  willBePopped: ->
    @savedSearch = ""

  openOptionOrError: (e) ->
    if maybeDisplayMemberLimitsError($(e.target), @model)
      Util.stop(e)
      return
    @openOption(e)



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-members-view.coffee